import { Component, inject } from "@angular/core";
import { SystemSearchPresetRestService } from "@app/services/hal/system-search-preset-rest.service";
import { SystemSearchPreset } from "@app/models/rest/system-search-preset";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent
} from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatActionList, MatListItem } from "@angular/material/list";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: "app-open-preset-dialog",
  templateUrl: "./open-preset-dialog.component.html",
  styleUrls: ["./open-preset-dialog.component.css"],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatActionList,
    MatListItem,
    MatIcon
  ]
})
export class OpenPresetDialogComponent {
  systemSearchPresetRestService = inject(SystemSearchPresetRestService);
  dialogRef = inject<MatDialogRef<OpenPresetDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  available: SystemSearchPreset[] = [];

  constructor() {
    const systemSearchPresetRestService = this.systemSearchPresetRestService;

    systemSearchPresetRestService
      .getPage({
        params: { projection: "list" },
        pageParams: { size: 500 },
        sort: { searchName: "ASC" }
      })
      .subscribe((value) => {
        this.available = value.resources;
      });
  }

  selectView(id: number, entityName: string) {
    this.dialogRef.close({
      id: id,
      entityName: entityName
    });
  }
}
